/* Product-page visibility and control-state repair. Native Shopify form owns cart submission. */
(() => {
  'use strict';
  const instances = new Map();
  const style = document.createElement('style');
  style.textContent = `
    product-sticky-form.ms-sticky-ready > .product-sticky-form__card {
      opacity: 0 !important; visibility: hidden !important;
      transform: translateY(15px) !important; pointer-events: none !important;
    }
    product-sticky-form.ms-sticky-ready[data-ms-sticky-visible] > .product-sticky-form__card {
      opacity: 1 !important; visibility: visible !important;
      transform: translateY(0) !important; pointer-events: auto !important;
    }
    product-sticky-form.ms-sticky-ready {
      padding-bottom: env(safe-area-inset-bottom, 0px);
    }
    product-sticky-form[data-ms-fullwidth-sticky] {
      width: 100%; max-width: none;
      inset-inline: 0; inset-block-end: 0; padding-bottom: 0;
    }
    product-sticky-form[data-ms-fullwidth-sticky] > .product-sticky-form__card {
      position: relative; border-radius: 0;
      padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
      border-inline: 0; border-block-end: 0;
      gap: 10px;
    }
    product-sticky-form[data-ms-fullwidth-sticky] .product-sticky-form__variant {
      grid-template-columns: minmax(0, 1fr); gap: 10px;
    }
    product-sticky-form[data-ms-fullwidth-sticky] .ms-sticky-details {
      min-width: 0; padding-inline-end: 48px; gap: 4px;
      overflow-wrap: anywhere;
    }
    product-sticky-form[data-ms-fullwidth-sticky] .ms-sticky-purchase {
      grid-column: 1 / -1; width: 100%; height: auto; min-height: 48px;
      padding: 12px 16px;
    }
    product-sticky-form[data-ms-fullwidth-sticky] .ms-sticky-close {
      position: absolute; inset-block-start: 6px; inset-inline-end: 10px;
      display: grid; place-items: center; width: 44px; height: 44px;
      padding: 0; border: 0; background: transparent; color: inherit;
      font: inherit; font-size: 28px; line-height: 1; cursor: pointer;
      z-index: 1;
    }
    product-sticky-form[data-ms-fullwidth-sticky] .ms-sticky-close:focus-visible {
      outline: 2px solid currentColor; outline-offset: -4px;
    }
    html:has(product-sticky-form[data-ms-fullwidth-sticky][data-ms-sticky-visible]) shopify-chat::part(activator) {
      transform: translateY(calc(-1 * var(--ms-fullwidth-sticky-height, 200px)));
    }
    @media (max-width: 767px) {
      html:has(.mobile-dock.active, .mobile-dock-section.shopify-active, .mobile-dock > .dock__item:focus-visible) product-sticky-form[data-ms-fullwidth-sticky] {
        transform: translateY(calc(-1 * var(--mobile-dock-height, 0px)));
      }
      html:has(product-sticky-form[data-ms-fullwidth-sticky][data-ms-sticky-visible]) shopify-chat::part(activator) {
        transform: translateY(calc(-1 * (var(--ms-fullwidth-sticky-height, 200px) + var(--mobile-dock-height, 0px))));
      }
    }
    @media (min-width: 768px) {
      /* Desktop: one compact row - image | name + price | Add to cart | X */
      product-sticky-form[data-ms-fullwidth-sticky] > .product-sticky-form__card {
        padding: 10px 64px 10px 16px;
      }
      product-sticky-form[data-ms-fullwidth-sticky] .product-sticky-form__variant {
        grid-template-columns: 48px minmax(0, 1fr) minmax(220px, 320px);
        align-items: center;
      }
      product-sticky-form[data-ms-fullwidth-sticky] .product-sticky-form__variant.no-image {
        grid-template-columns: minmax(0, 1fr) minmax(220px, 320px);
      }
      product-sticky-form[data-ms-fullwidth-sticky] .ms-sticky-details {
        padding-inline-end: 0; text-align: start; justify-items: start;
      }
      product-sticky-form[data-ms-fullwidth-sticky] .ms-sticky-details * {
        text-align: start; justify-content: flex-start;
      }
      product-sticky-form[data-ms-fullwidth-sticky] .ms-sticky-purchase {
        grid-column: auto; grid-row: 1; grid-column-end: -1;
      }
      product-sticky-form[data-ms-fullwidth-sticky] .ms-sticky-close {
        inset-block-start: 50%; transform: translateY(-50%);
      }
    }
    /* Desktop: the product info column is position:sticky (its own stacking layer), which let later
       page sections paint over the fixed bar and hide its price and button. Lift that column just
       below the header (z-index 20) while the bar is showing. */
    .product__info:has(> product-sticky-form[data-ms-sticky-visible]) {
      z-index: 19;
    }
    @media (max-width: 767px) {
      /* Follow the theme's own dock show/hide states so the purchase button is never under the bottom dock. */
      product-sticky-form[data-ms-fullwidth-sticky] {
        transition: transform var(--animation-primary, 0.3s ease);
      }
      product-sticky-form[data-ms-fullwidth-sticky].ms-dock-up {
        transform: translateY(calc(-1 * var(--mobile-dock-height, 0px))) !important;
      }
      html.ms-sticky-dock-up shopify-chat::part(activator) {
        transform: translateY(calc(-1 * (var(--ms-fullwidth-sticky-height, 200px) + var(--mobile-dock-height, 0px)))) !important;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      product-sticky-form[data-ms-fullwidth-sticky] > .product-sticky-form__card {
        transition: none !important;
      }
    }`;
  document.head.appendChild(style);

  function mount(sticky) {
    if (instances.has(sticky)) return;
    let frame = 0;
    let observedForm = null;
    let dismissed = false;
    // Mirror the theme's own mobile-dock visibility states (see mobile-dock.css).
    const dockEl = document.querySelector('.mobile-dock');
    const dockSection = dockEl && dockEl.closest('.mobile-dock-section');
    const headerEl = document.querySelector('.header-section');
    const dockObserver = dockEl ? new MutationObserver(schedule) : null;
    if (dockObserver) {
      [dockEl, dockSection, headerEl].forEach(el => {
        if (el) dockObserver.observe(el, { attributes: true, attributeFilter: ['class'] });
      });
    }
    function dockShown() {
      if (!dockEl || window.innerWidth >= 768) return false;
      return !!((headerEl && headerEl.classList.contains('header-sticky') && headerEl.classList.contains('header-hidden')) ||
        (dockSection && (dockSection.classList.contains('active') || dockSection.classList.contains('shopify-active'))) ||
        dockEl.classList.contains('active') || dockEl.querySelector(':scope > .dock__item:focus-visible'));
    }
    const closeButton = sticky.querySelector('[data-ms-sticky-close]');
    const card = sticky.querySelector('.product-sticky-form__card');
    let cardHeight = 0;
    const observer = new MutationObserver(schedule);
    const resize = window.ResizeObserver ? new ResizeObserver(entries => {
      if (sticky.hasAttribute('data-ms-fullwidth-sticky')) {
        const entry = entries.find(entry => entry.target === card);
        const height = entry && entry.borderBoxSize && entry.borderBoxSize[0]?.blockSize;
        if (height && height !== cardHeight) {
          cardHeight = height;
          document.documentElement.style.setProperty('--ms-fullwidth-sticky-height', height + 'px');
        }
      }
      schedule();
    }) : null;

    function update() {
      frame = 0;
      if (!sticky.isConnected) { destroy(); return; }
      const form = document.getElementById(sticky.getAttribute('form'));
      const button = sticky.querySelector('button[type="submit"]');
      const mainButton = form && form.querySelector('button[type="submit"]');
      if (!form || !button || !mainButton) {
        sticky.removeAttribute('data-ms-sticky-visible');
        return;
      }
      if (form !== observedForm) {
        observer.disconnect();
        if (resize) resize.disconnect();
        observedForm = form;
        observer.observe(form, { subtree: true, childList: true, characterData: true,
          attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'hidden', 'value', 'aria-label'] });
        if (resize) {
          resize.observe(form);
          if (card) resize.observe(card);
        }
      }
      // Read current geometry rather than relying on stale intersection transitions.
      const rect = mainButton.getBoundingClientRect();
      const visible = !dismissed && rect.width > 0 && rect.height > 0 && rect.bottom <= 0;
      // Keep the bar above Shopify's theme-preview toolbar (only present when previewing a draft).
      const previewBar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame') || document.getElementById('preview-bar-iframe');
      let previewOffset = 0;
      if (previewBar) {
        const pr = previewBar.getBoundingClientRect();
        if (pr.height > 0 && pr.top < window.innerHeight && getComputedStyle(previewBar).display !== 'none') {
          previewOffset = Math.max(0, Math.round(window.innerHeight - pr.top));
        }
      }
      sticky.style.bottom = previewOffset ? previewOffset + 'px' : '';
      const up = dockShown();
      sticky.classList.toggle('ms-dock-up', up);
      sticky.classList.add('ms-sticky-ready');
      sticky.toggleAttribute('data-ms-sticky-visible', visible);
      sticky.inert = !visible;
      document.documentElement.classList.toggle('ms-sticky-dock-up', visible && up);
      button.setAttribute('form', form.getAttribute('id'));
      const variant = form.querySelector('[name="id"]');
      button.disabled = mainButton.disabled || !variant || variant.disabled || !variant.value;
      ['aria-disabled', 'aria-busy', 'aria-label'].forEach(name => {
        if (mainButton.hasAttribute(name)) button.setAttribute(name, mainButton.getAttribute(name));
        else button.removeAttribute(name);
      });
      const label = button.querySelector('[data-sold-out]');
      const mainLabel = mainButton.querySelector('.btn-text > span') || mainButton.querySelector('.btn-text');
      if (label && mainLabel) label.textContent = mainLabel.textContent;
      const error = form.querySelector('.product-form__error-message');
      const stickyError = sticky.querySelector('.product-form__error-message');
      if (error && stickyError) {
        stickyError.textContent = error.textContent;
        stickyError.hidden = error.hidden;
      }
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    function dismiss() {
      dismissed = true;
      // Hide immediately; do not wait for another scroll or create layout work.
      sticky.removeAttribute('data-ms-sticky-visible');
      sticky.inert = true;
      document.documentElement.classList.remove('ms-sticky-dock-up');
    }
    function destroy() {
      cancelAnimationFrame(frame);
      observer.disconnect();
      if (resize) resize.disconnect();
      if (dockObserver) dockObserver.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('pageshow', schedule);
      document.removeEventListener('variant:change', schedule);
      if (closeButton) closeButton.removeEventListener('click', dismiss);
      instances.delete(sticky);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('variant:change', schedule);
    if (closeButton) closeButton.addEventListener('click', dismiss);
    instances.set(sticky, { schedule, destroy });
    schedule();
  }
  function scan() {
    instances.forEach((instance, element) => {
      if (!element.isConnected) instance.destroy();
    });
    document.querySelectorAll('product-sticky-form').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', scan);
})();
